import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import QuestionCards from './components/QuestionCards/QuestionCards'

import { getQuiz } from 'src/api/quizzes/quizzes'
import { IQuiz } from 'src/api/quizzes/types'
import { LoadingScreen } from 'src/components/Loading'
import { LANDING, COMPLETE_QUIZ } from 'src/constants/routes'
import { iRootState } from 'src/store'

const stateSelector = (state: iRootState) => ({
  userId: state.user.data?.id,
  isAuthResolved: state.user.isAuthResolved,
})

const Quiz: React.FC = () => {
  const { id } = useParams()
  const { push } = useHistory()

  const { userId, isAuthResolved } = useSelector(stateSelector)

  const [quiz, setQuiz] = React.useState<IQuiz>()
  const [error, setError] = React.useState<string>()

  React.useEffect(() => {
    const fetchQuiz = async () => {
      try {
        const quizData = await getQuiz(id)
        setQuiz(quizData)
        if (quizData.completed) {
          // @TODO: notify user about already completed quiz
          push(COMPLETE_QUIZ.replace(':id', id))
        }
      } catch (e) {
        setError('Fetching quiz data failed')
        console.error(e)
      }
    }

    if (isAuthResolved && userId) {
      fetchQuiz()
    }

    if (isAuthResolved && !userId) {
      push(LANDING)
    }
  }, [id, isAuthResolved, push, userId])

  if (error) {
    return <h3>{error}</h3>
  }

  if (!quiz) {
    return <LoadingScreen />
  }

  return <QuestionCards quiz={quiz} />
}

export default Quiz
